import { updateAdminUser } from './updateAdminUser';
import { UpdateCareAdvisorUserPayload, updateCareAdvisorUser } from './updateCareAdvisorUser';
import { UserProfile, UserRoleName } from './types/UserProfile';

// Write counterpart to getStaffUserById: /care_advisor/users/{id} is guarded for
// the CareAdvisor role alone, so saving the profile as an Admin or SuperAdmin
// returned 403. The admin PATCH accepts the same payload (its own type is a
// superset), so the form can save through either.
const ADMIN_ROLES: ReadonlySet<string> = new Set([
  UserRoleName.Admin,
  UserRoleName.SuperAdmin,
  UserRoleName.OrganizationAdmin,
]);

export const updateStaffUser = async (
  user_id: number,
  payload: UpdateCareAdvisorUserPayload,
  role: string,
): Promise<UserProfile> =>
  ADMIN_ROLES.has(role) ? updateAdminUser(user_id, payload) : updateCareAdvisorUser(user_id, payload);
